<template>
  <!--  :class="{-->
  <!--  show: showStatus,-->
  <!--  success: socketStatus === WebSocket.OPEN,-->
  <!--  process: socketStatus === WebSocket.CONNECTING-->
  <!--  }"-->
  <!--  || !onLine || socketStatus === WebSocket.CLOSED-->
  <!--  v-show="network==='true'"-->
  <!--  v-show="!onLine || socketStatus === WebSocket.CLOSED"-->
  <div
    v-show="!onLine || socketStatus === WebSocket.CLOSED"
    class="socket-status show"
  >
    <template>
      网络异常，请检查网络并尝试刷新页面！
    </template>
    <!--    <template v-else>-->
    <!--      {{ message }}-->
    <!--    </template>-->
  </div>
</template>

<script>
export default {
  name: "socket-status",
  computed: {
    ...mapState(["socketStatus"]),
    ...mapState({
      isReconnect: state => state.ws.isReconnect
    }),
    message() {
      let status = {
        [WebSocket.CONNECTING]: "连接中",
        [WebSocket.OPEN]: "连接成功",
        [WebSocket.CLOSING]: "正在关闭",
        [WebSocket.CLOSED]: "连接已断开"
      };
      return _.get(status, `[${this.socketStatus}]`, this.socketStatus);
    }
  },
  data() {
    return {
      onLine: navigator.onLine,
      WebSocket: window.WebSocket,
      showStatus: false,
      successTimeout: undefined
    };
  },
  mounted() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);
  },
  watch: {
    socketStatus: {
      handler(newVal) {
        console.log("socket状态" + JSON.stringify(newVal), WebSocket.OPEN);
        if (newVal === WebSocket.OPEN) {
          if (this.successTimeout) clearTimeout(this.successTimeout);
          this.successTimeout = setTimeout(() => {
            this.showStatus = false;
          }, 2000);
        } else {
          if (this.successTimeout) clearTimeout(this.successTimeout);
          if (newVal !== undefined) {
            this.showStatus = true;
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    updateOnlineStatus(e) {
      const { type } = e;
      this.onLine = type === "online";

      console.log(this.onLine, this.isReconnect);
      if (this.onLine && this.isReconnect) {
        // alert(this.isReconnect)
        window.location.reload();
      }
    },
    reConnect() {
      utils.socket.reConnect();
    }
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);
  }
};
</script>

<style scoped lang="less">
.socket-status {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  padding: 0 15px;
  height: 30px;
  top: -30px;
  z-index: 100;
  line-height: 30px;
  font-size: 14px;
  color: #fff;
  background-color: #de2d2d;
  border-radius: 0 0 4px 4px;
  transition-duration: 0.3s;

  &.process {
    background-color: #1a8fc6;
  }

  &.success {
    background-color: #00680d;
  }

  .btn {
    text-decoration: underline;
    cursor: pointer;
  }

  &.show {
    top: 0;
  }
}
</style>
